// @ts-ignore
/* eslint-disable */
import request from '../../utils/request';

/** 获取用户收货地址信息 # **获取AccessToken** 
<a href='http://auth-service-beta2.shrise.cn/doc.html#/default/token-controller/generateUserAccessTokenUsingPOST' target='_blank'>点击此处获取测试站用户AccessToken</a>参数示例: 
  ```
{
  "productType": 171,
  "userId": 240
}
  ```
 GET /user/address */
export async function userAddressUsingGET(options?: { [key: string]: any }) {
  return request<API.BaseResultUcUserAddress>('/user/address', {
    method: 'GET',
    ...(options || {}),
  });
}

/** 创建/更新用户收货地址信息 # **获取AccessToken** 
<a href='http://auth-service-beta2.shrise.cn/doc.html#/default/token-controller/generateUserAccessTokenUsingPOST' target='_blank'>点击此处获取测试站用户AccessToken</a>参数示例: 
  ```
{
  "productType": 171,
  "userId": 240
}
  ```
 POST /user/address/create */
export async function userAddressCreateUsingPOST(
  body: API.gengxinyonghushouhuodezhixinxi,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultVoid>('/user/address/create', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 获取用户收货地址信息（阿里智能验证码版） # **获取AccessToken** 
<a href='http://auth-service-beta2.shrise.cn/doc.html#/default/token-controller/generateUserAccessTokenUsingPOST' target='_blank'>点击此处获取测试站用户AccessToken</a>参数示例: 
  ```
{
  "productType": 171,
  "userId": 240
}
  ```
 POST /user/address/v2 */
export async function userAddressV2UsingPOST(
  body: API.UserAddressV2Req,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultUcUserAddress>('/user/address/v2', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}
